export enum DownloadActivityZipPageParams {
  ownerUuid = "ownerUuid",
  activityZipUuid = "activityZipUuid",
  ownerType = "ownerType",
}
